import { AdvancedOptions, Campaign, LocationDetails, LocationStats } from '@dev/ee-api/ee-api-models';

import i18n from '@/../i18n';

import { WorldMapsEnum, MapTooltipRow, DataItem } from './GeographyInterface';

export const getTrackingDisabledInfo = (advancedOptions: AdvancedOptions, campaign?: Campaign): string => {
    const campaignTrackingOptions = campaign?.TrackingOptions;

    const isClicksTrackedDisabled =
        !advancedOptions?.EnableClickTracking || (campaignTrackingOptions && !campaignTrackingOptions.TrackClicks);
    const isOpenTrackingDisabled =
        !advancedOptions?.EnableOpenTracking || (campaignTrackingOptions && !campaignTrackingOptions.TrackOpens);

    if (isClicksTrackedDisabled && isOpenTrackingDisabled) {
        return `${i18n.t('openandclicktrackingdisabled')} `;
    } else if (isClicksTrackedDisabled) {
        return `${i18n.t('clicktrackingdisabled')} `;
    } else if (isOpenTrackingDisabled) {
        return `${i18n.t('opentrackingdisabled')} `;
    }
    return '';
};

export function isWorldMapSelected(selectedMap: WorldMapsEnum | string): boolean {
    return selectedMap === WorldMapsEnum.World;
}

export const getMapData = (
    data: DataItem[],
    isWorldMapSelected: boolean,
    opensDescrition: string,
    clicksDescrition: string
): {
    countryId: string;
    name: string;
    multipleValues: MapTooltipRow[];
}[] =>
    data
        ?.filter((CountryData: DataItem) => CountryData?.OpenCount > 0 || CountryData?.ClickCount > 0)
        .map(
            (
                CountryData: DataItem
            ): {
                countryId: string;
                name: string;
                multipleValues: MapTooltipRow[];
            } => {
                const countryId = isWorldMapSelected
                    ? (CountryData as LocationStats)?.CountryISO?.toLowerCase()
                    : ((CountryData as LocationDetails)?.State as string);

                const name = isWorldMapSelected
                    ? (CountryData as LocationStats)?.Country
                    : (CountryData as LocationDetails)?.State;
                return {
                    countryId,
                    name,
                    multipleValues: [
                        { value: CountryData.OpenCount, description: opensDescrition },
                        { value: CountryData.ClickCount, description: clicksDescrition },
                    ],
                };
            }
        ) ?? [];
